import { createSearchParams } from "react-router-dom"

import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { SettingsCallBackPayoutUi } from "@src/widgets/onboarding/ui/tours/ApiIntegration/SettingsCallBackPayoutUi"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class SettingsCallBackPayout extends TourStepBase {
  component = SettingsCallBackPayoutUi
  name = `${ONBOARDING_TOURS.API_INTEGRATION}_SettingsCallBackPayout`

  constructor() {
    super({
      highlightElements: ["#GENERATED_ID_CALLBACKURLFORM_FORM_VOID_1"],
      placement: TOUR_MODAL_PLACEMENTS.TOP_LEFT,
    })
  }

  action() {
    return router.navigate({
      pathname: paths.settings,
      search: `?${createSearchParams({ tab: "cbp" })}`,
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      subtitle: "Receive notifications for every event",
      title: "Callback Payout URL",
    }
  }
}
